import React from "react";
import logo from "../../Assets/img/logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagramSquare,
  faYoutubeSquare
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <div id="footer">
      <div id="footer-inner">
        <div className="footer-logo">
          <img src={logo} />
        </div>
        <div className="footer-copyright">© 2020</div>
        <div className="footer-social-links">
          <a
            href="https://www.facebook.com/iwwmphotography/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon size="lg" icon={faFacebookSquare} />
          </a>
          <a
            href="https://www.instagram.com/iw.wm/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon size="lg" icon={faInstagramSquare} />
          </a>
          <a
            href="https://www.youtube.com/channel/UCgTvSbCLJsTlRI3bVr6JBxg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon size="lg" icon={faYoutubeSquare} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
